import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { environment } from '@manage/env/environment';
import * as Sentry from '@sentry/angular';
import { SENTRY_IGNORE_ERRORS, sentryBeforeSend } from '@agilox/sentry';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

if (environment.production) {
	enableProdMode();

	Sentry.init({
		dsn: 'https://e6fd6d35bcef03733466006ce335ec0d@o919676.ingest.us.sentry.io/4510980552065024',
		replaysSessionSampleRate: 0.1,
		replaysOnErrorSampleRate: 1.0,
		integrations: [
			Sentry.browserTracingIntegration(),
			Sentry.replayIntegration({
				networkDetailAllowUrls: [environment.server, environment.serverNew],
				networkCaptureBodies: true,
			}),
		],
		tracePropagationTargets: ['https://manage.agilox.net'],
		ignoreErrors: SENTRY_IGNORE_ERRORS,
		beforeSend: sentryBeforeSend,
		tracesSampleRate: 0.5,
	});
}

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
